import React from 'react'
import {
  formatCutoffTimeAsAmPm, formatDeliveryDate, formatDeliveryType, dateFormatterUTC,
} from '@usap/core'
import Availability from './Availability'
import {
  StyledLastMileContainer,
  StyledHeading,
  StyledGetIt,
  StyledDeliveryDate,
  StyledSubtitle,
  StyledSeeAllDates,
} from './DeliveryDatesLastMile.css'
import { GetShippingIcon } from './GetShippingIcon'

const DeliveryDatesLastMile = ({
  ground, data, dataTestId, handleSeeAllDates, showPopup, shouldShowPopup, optionsCount, widget = 'cart',
}) => {
  const {
    method, deliveryDate, cutoffTime,
  } = ground

  const deliveryMethod = cutoffTime ? formatDeliveryType(deliveryDate, cutoffTime) : method

  let deliveryLabel = 'Standard'
  let dataTestIdValue = `non-diligent-sd-${widget}-badge`

  switch (deliveryMethod) {
    case 'SameDay':
      deliveryLabel = 'Same-Day'
      dataTestIdValue = `sd-${widget}-badge`
      break
    case 'NextDay':
      deliveryLabel = 'Next-Day'
      dataTestIdValue = `nd-${widget}-badge`
      break
    case 'NextBusinessDay':
      deliveryLabel = 'Next Business Day'
      dataTestIdValue = `nbd-${widget}-badge`
      break
    case '2 Day':
      deliveryLabel = '2nd Business Day'
      dataTestIdValue = `non-diligent-2bd-${widget}-badge`
      break
    case 'Overnight':
      deliveryLabel = 'Next Business Day'
      dataTestIdValue = `non-diligent-nbd-${widget}-badge`
      break
    case 'Economy':
      deliveryLabel = 'Economy'
      dataTestIdValue = `non-diligent-en-${widget}-badge`
      break
    default:
      break
  }

  return (
    <StyledLastMileContainer data-testid={dataTestIdValue}>
      <StyledHeading>
        <GetShippingIcon dMethod={deliveryMethod} />
        <StyledGetIt>{'Get it '}</StyledGetIt>
        <StyledDeliveryDate>
          {cutoffTime
            ? formatDeliveryDate(deliveryDate, false, cutoffTime ?? '00:00:00')
            : dateFormatterUTC(deliveryDate)}
        </StyledDeliveryDate>
      </StyledHeading>
      <StyledSubtitle>
        {deliveryMethod === 'SameDay'
          ? `${deliveryLabel} Delivery \u2014 order by ${formatCutoffTimeAsAmPm(cutoffTime)}.`
          : `${deliveryLabel} Delivery`}
        {optionsCount > 1 && (
          <StyledSeeAllDates
            type="button"
            data-testid={dataTestId}
            onClick={handleSeeAllDates}
          >
            See All Dates
          </StyledSeeAllDates>
        )}
      </StyledSubtitle>
      <Availability
        data={data}
        showPopup={showPopup}
        shouldShowPopup={shouldShowPopup}
        isLastMile
      />
    </StyledLastMileContainer>
  )
}

export default DeliveryDatesLastMile
